import MiniSearch from "minisearch";

const countrySearch = new MiniSearch({
  fields: ["name", "fragments"],
  storeFields: ["name", "documents", "documents_count", "2018", "2023", "id", "region_id"],
  searchOptions: {
    prefix: true,
    fuzzy: 0.1
  }
});

export default countrySearch;
